import React, { useContext, useEffect, useState } from 'react'
import PMBCodeSelectionCompoonent from '../../../../../../components/icd/PMBCodeSelectionCompoonent'
import Patient from '../../../../../../libs/api/services/Patient'
import Questionnaire from '../../../../../../libs/api/services/Questionnaire'
import QuestionnaireBuilderContext from '../../QuestionnaireBuilderProvider'
import { AdminEditText, AdminLayoutWrapper, CommonLayoutWrapper } from '../QBuilderComponentMultiSelect'
import QBuilderFieldLink from '../QBuilderFieldLink'

export default function QBuilderPMBCodesItem({
    Component,
    activeQuestionnaireAssignment,
    accessTypes,
    onAction,
    idx,
    edit,
    view,
    defaultMode,
    SectionComponents,
    values, }) {
    const { SetComponentValue, GetComponentValues, SetResponse, ComponentAnswers } = useContext(QuestionnaireBuilderContext)
    const [mode, setMode] = useState(edit ? '' : '')
    const [ComponentResponse, setComponentResponse] = useState(ComponentAnswers[Component.id])
    // const [Link, setLink] = useState({
    //     autoFill: false,
    //     updateRecords: false
    // })

    const onChangeValue = (value) => SetResponse(Component, value, true)
    useEffect(() => {
        const _checkLinkedFields = (answer) => {
            // ComponentAnswers[Component.id]
            if (!answer || answer === "")
                Questionnaire
                    .GetLinkPatientProfile(Component.id)
                    .then((r) => {
                        // setLink(r)
                        // setResponse(r)
                        if (r.autoFill && view !== "New") {
                            Patient
                                .GetPatientProfileDetail(activeQuestionnaireAssignment.assignedTo.id, r.linkedValue.id)
                                .then((d) => {
                                    onChangeValue(d.detail)
                                    setComponentResponse(d.detail)
                                }).catch((e) => { })
                        }
                    }).catch((e) => { })
        }
        _checkLinkedFields(ComponentAnswers[Component.id])

    }, [])
    // if (!accessTypes) return <></>
    return <CommonLayoutWrapper
        OnEdit={() => setMode('Edit Text')}
        edit={edit}
        mode={mode}
        accessTypes={accessTypes}
        AdminMode={<AdminLayoutWrapper
            Component={Component}
            mode={mode}
            setMode={setMode}
            Tabs={{
                "Edit Text": {
                    mode: "Set Text",
                    component: <AdminEditText Component={Component} />
                },
                "Link": {
                    mode: "Link Field",
                    component: <QBuilderFieldLink ComponentId={Component.id} />
                },
            }}
        />}
        NormalMode={
            <>
                {GetComponentValues(Component.ids)["Question"]}
                {
                    accessTypes.includes('Admin')
                        ?
                        <PMBCodeSelectionCompoonent
                            view={view}
                            defaultValue={null}
                            enabled={mode === 'Discover'}
                            onSelected={(r) => { }} />
                        :
                        accessTypes.includes('Edit')
                            ?
                            <PMBCodeSelectionCompoonent
                                view={view}
                                defaultValue={ComponentResponse}
                                enabled={mode === 'Discover'}
                                onSelected={(r) => onChangeValue(r)} />
                            :
                            <div>{ComponentResponse}</div>
                }

            </>
        }
    />
}

// ({ cache, state, activeQuestionnaireAssignment, edit, defaultMode, view, mode, onAction, idx, ComponentId, onSetData }) {
//     const [smode, setSMode] = useState(edit ? 'Details' : '')
//     const isMounted = useRef(false)
//     const [responses, setResponses] = useState()
//     const [loading, setLoading] = useState(true)
//     const [properties, setProperties] = useState()
//     const _MODES = ['Details']

//     const _loadProperties = async () => {
//         if (cache) { setProperties(cache.properties) } else {
//             setProperties(await QBuilderGenerics.loadComponentProperties(ComponentId))
//         }
//     }
//     const _loadResponses = async () => {

//         try {
//             const _resp = await QBuilderGenerics.loadComponentReponses(activeQuestionnaireAssignment.id, ComponentId)
//             try {
//                 setResponses(JSON.parse(_resp.answer))
//             } catch (e) {
//                 setResponses(_resp.answer)
//             }

//         } catch (e) {
//             // console.error('_loadResponses', e)
//         }
//         setLoading(false)
//     }
//     const _load = async () => {
//         await _loadProperties()
//         await _loadResponses()
//         isMounted.current = true
//         setLoading(false)
//     }
//     useEffect(() => {
//         // onLoad
//         _load()
//     }, [])

//     useEffect(() => {
//         // Dont open edit window if not a new state
//         if (defaultMode && defaultMode === 'Overview')
//             setSMode('')
//     }, [defaultMode])

//     const _handleSetProperty = async (k, v) => setProperties(await QBuilderGenerics.setProperty(ComponentId, k, v))
//     const _handlGetProperty = (k) => { try { return QBuilderGenerics.getProperty(properties, k) } catch (e) { } }

//     //const _handleSetResponse = async (r, commit) => onSetData(ComponentId, JSON.stringify(r), commit)
//     const _handleSetResponse = async (r, commit) => onSetData(JSON.stringify(r), commit)
//     const _handlGetResponse = () => responses ? responses : []

//     /*
//     *   Edit options
//     */
//     const _rendenderEdit = () => {
//         var ret = []
//         switch (smode) {
//             case 'Details':
//                 ret = <QBuilderGeneralQuestionInfo
//                     properties={properties}
//                     onChanged={(k, v) => _handleSetProperty(k, v)} />
//                 break;
//             default:
//                 return <></>
//         }
//         return (

//             <QBuilderSideMenuContainer onAction={onAction} idx={idx} isNew={false} onClose={() => setSMode('')} subMenus={_MODES} mode={mode} setMode={(m) => setSMode(m)}>
//                 {ret}
//             </QBuilderSideMenuContainer>
//         )
//     }

//     /*
//         Render Components
//     */
//     const _rendenderMain = () => {
//         var _ret = []
//         _ret = <PMBCodeSelectionCompoonent
//             view={view}
//             defaultValue={_handlGetResponse()}
//             enabled={mode === 'Discover'}
//             onSelected={(r) => _handleSetResponse(r, true)} />

//         return (<QBuilderEditWrapper
//             enable={edit}
//             isEditing={smode !== ''}
//             onEdit={() => setSMode('Details')}>
//             <QBuilderValidationWrapper
//                 required={_handlGetProperty('Required')}
//                 question={_handlGetProperty('Question')}
//             >
//                 {_ret}
//             </QBuilderValidationWrapper>
//         </QBuilderEditWrapper>)
//     }

//     const _render = () => {
//         return (
//             <>
//                 {_rendenderEdit()}
//                 {_rendenderMain()}
//             </>
//         )
//     }
//     // if(!properties) return <></>
//     if (loading) return <div className='text-center'><FontAwesomeIcon icon={faSpinner} spin /></div>
//     return (
//         <div>
//             {_render()}
//         </div>
//     )
// }
